import { Injectable } from '@angular/core';
@Injectable()

export class ConfigTest {

  public ENDPOINT_API: string = 'WSprecheck/';
  
}